import customerInstance from '../instance'

const fetchDeliveryConfigs = (page, size) => {
  return customerInstance.get('/delivery-configs/' + ((page || size) ? '?page=' + page + '&size=' + size : ''))
}

export default fetchDeliveryConfigs
